import { render, staticRenderFns } from "./YourDetailsStep.vue?vue&type=template&id=6b9f0b9b&scoped=true&"
import script from "./YourDetailsStep.vue?vue&type=script&lang=ts&"
export * from "./YourDetailsStep.vue?vue&type=script&lang=ts&"
import style0 from "./YourDetailsStep.vue?vue&type=style&index=0&id=6b9f0b9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f0b9b",
  null
  
)

export default component.exports